import React from 'react';

import './search.css';

import ReplaceForm from '../replace/replace.js';

import Cancel from '../../assets/icons/cancel.png';
import ChevronRight from '../../assets/icons/chevronright.png';
import ChevronDown from '../../assets/icons/chevrondown.png';
import SearchDown from '../../assets/icons/searchdown.png';
import SearchUp from '../../assets/icons/searchup.png';
import Font from '../../assets/icons/font.png';
import TextBox from '../../assets/icons/text-box.png';

import Button from '../../../../../../components/bases/button/button.js';

import { GlobalContext } from '../../../../../../utils/globalprovider';

import { trapFocusElements } from '../../utils/functions.js';

class Search extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    this.state = {
      text: '',
    };

    this.onKeyDown = this.onKeyDown.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.search.showSearch && this.props.search.showSearch === true) {
      this.updateText('');
      document.querySelector('#txtSearch').focus();
    }
  }

  onKeyDown(event) {
    event.preventDefault();
    event.stopPropagation();

    if (event.key === 'Tab') {
      const focusedElement = document.activeElement;

      trapFocusElements(
        focusedElement,
        'input[type="text"], [role="button"]',
        event.shiftKey
      );

      return;
    }

    const input = event.target;
    const text = this.state.text;

    if (!event.ctrlKey) {
      var char = event.key;
      if (char.length === 1) {
        var code = char.codePointAt(0);

        if (code >= 32) {
          let start = input.selectionStart;
          let end = input.selectionEnd;

          this.updateText(
            text.substring(0, start) + event.key + text.substring(end)
          );
          this.setCursorPosition(input, start + 1);
        }

        return;
      }

      if (event.key === 'Enter') {
        this.props.onNextPosition();
        return;
      }

      if (event.key === 'Backspace') {
        this.onBackspace(input);
        return;
      }

      if (event.key === 'Delete') {
        this.onDelete(input);
        return;
      }

      if (event.key === 'ArrowLeft') {
        if (input.selectionStart === 0) return;

        this.setCursorPosition(input, input.selectionStart - 1);
        return;
      }

      if (event.key === 'ArrowRight') {
        if (input.selectionStart === text.length) return;

        this.setCursorPosition(input, input.selectionStart + 1);
        return;
      }

       if (event.key === 'Home') {
        this.setCursorPosition(input, 0);
        return;
      }

      if (event.key === 'End') {
        this.setCursorPosition(input, text.length);
        return;
      }

      if (event.key === 'F3') {
        this.props.onNextPosition();
        return;
      }

      if (event.key === 'F4') {
        this.props.onPrevPosition();
        return;
      }
    } else {
      if (event.key === 'v') {
        const navigator = event.nativeEvent.view.navigator;
        this.onPaste(navigator, input);
        return;
      }

      if (event.key === 'a') {
        input.setSelectionRange(0, text.length);
        return;
      }

      if (event.key === 'ArrowLeft') {
        let start = input.selectionStart;
        let end = input.selectionEnd;

        if (start === 0) return;

        input.setSelectionRange(start - 1, end);
        return;
      }

      if (event.key === 'ArrowRight') {
        let start = input.selectionStart;
        let end = input.selectionEnd;

        if (end === text.length) return;

        input.setSelectionRange(start, end + 1);
        return;
      }

      if (event.key === 'f') {
        this.props.onSearchClose();
        return;
      }

      if (event.key === 'h') {
        if (this.props.readonly) {
          return;
        }

        if (this.props.search.showSearch && !this.props.search.showReplace) {
          this.props.onShowReplace();
          return;
        }

        this.props.onSearchClose();
        return;
      }
    }
  }

  async onPaste(navigator, input) {
    const permission = await navigator.permissions.query({
      name: 'clipboard-read',
    });

    if (permission.state === 'granted' || permission.state === 'prompt') {
      navigator.clipboard.readText().then((clipText) => {
        let start = input.selectionStart;
        let end = input.selectionEnd;

        const text = this.state.text;
        this.updateText(
          text.substring(0, start) + clipText + text.substring(end)
        );
      });
    } else {
      this.setState({
        popup: {
          ...this.state.popup,
          display: true,
          showIcon: true,
          text: {
            fr: "Permission d'accès au presse-papiers refusée.",
            en: 'Permission to access the clipboard denied.',
          },
        },
      });
    }
  }

  onBackspace(input) {
    let start = input.selectionStart;
    let end = input.selectionEnd;

    let selectedText = input.value.substring(start, end);
    const text = this.state.text;

    if (selectedText === '' && text.length === 1) {
      this.updateText('');
      return;
    }

    this.updateText(text.substring(0, start - 1) + text.substring(end));
    this.setCursorPosition(input, start - 1);
  }

  updateText(text) {
    this.setState({ text: text });
    this.props.onSearchChange(text);
  }

  onDelete(input) {
    let start = input.selectionStart;
    let end = input.selectionEnd;

    let selectedText = input.value.substring(start, end);
    const text = this.state.text;

    if (selectedText === '' && text.length === 1) {
      this.updateText('');
      return;
    }

    this.updateText(text.substring(0, start) + text.substring(end + 1));
    this.setCursorPosition(input, start);
  }

  setCursorPosition(inputElement, position) {
    setTimeout(() => {
      inputElement.setSelectionRange(position, position);
      inputElement.scrollLeft = inputElement.scrollWidth;
    }, 0);
  }

  onChange(event) {
    this.updateText(event.target.value);
  }

  render() {
    const lang = this.context.language;

    return (
      <div role="dialog" id="idSearch" aria-label="Rechercher ou remplacer">
        <div className="search-result">
          <ResultText
            lang={lang}
            currentPosition={this.props.search.currentPosition}
            totalWordsFounded={this.props.search.totalWordsFounded}
          />
        </div>
        <div
          className={`search ${
            this.props.search.showReplace && !this.props.readonly
              ? 'replace-active'
              : ''
          }`}
          role="search"
        >
          <div className="search-btn">
            <ButtonActivateReplace
              showReplace={this.props.search.showReplace}
              onShowReplace={this.props.onShowReplace}
              readonly={this.props.readonly}
            />
          </div>

          <div className="search-div">
            <div className="search-form">
              <label htmlFor="txtSearch" className="sr-only">
                {lang === 'fr' ? 'Rechercher' : 'Search'}
              </label>
              <input
                id="txtSearch"
                type="text"
                placeholder={lang === 'fr' ? 'Rechercher' : 'Search'}
                value={this.state.text}
                onKeyDown={this.onKeyDown}
                onChange={this.onChange}
              />

              <Button
                id="btnCaseSensitive"
                tooltip={{
                  fr: 'Respecter la casse',
                  en: 'Case sensitive',
                }}
                image={Font}
                width={16}
                height={16}
                toggle={true}
                toggled={this.props.search.caseSensitive}
                onClick={this.props.onCaseSensitive}
              ></Button>

              <Button
                id="btnMotEntier"
                tooltip={{
                  fr: 'Mot entier',
                  en: 'Whole word',
                }}
                image={TextBox}
                width={16}
                height={16}
                toggle={true}
                toggled={this.props.search.wholeWord}
                onClick={this.props.onWholeWord}
              ></Button>

              <Button
                id="btnPrevious"
                tooltip={{
                  fr: 'Correspondance précédente',
                  en: 'Previous match',
                }}
                image={SearchUp}
                width={16}
                height={16}
                onClick={this.props.onPrevPosition}
              ></Button>

              <Button
                id="btnNext"
                tooltip={{
                  fr: 'Correspondance suivante',
                  en: 'Next match',
                }}
                image={SearchDown}
                width={16}
                height={16}
                onClick={this.props.onNextPosition}
              ></Button>

              <Button
                id="btnClose"
                tooltip={{
                  fr: 'Fermer',
                  en: 'Close',
                }}
                image={Cancel}
                width={16}
                height={16}
                onClick={this.props.onSearchClose}
              ></Button>
            </div>
            <ReplaceForm
              lang={lang}
              showReplace={
                this.props.search.showReplace && !this.props.readonly
              }
              onReplaceOne={this.props.onReplaceOne}
              onReplaceAll={this.props.onReplaceAll}
              onReplaceClose={this.props.onSearchClose}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Search;

function ButtonActivateReplace({ showReplace, onShowReplace, readonly }) {
  if (readonly) {
    return <></>;
  }

  let img = showReplace ? ChevronDown : ChevronRight;
  return (
    <Button
      id="btnActivateReplace"
      tooltip={{
        fr: 'Activer/désactiver le remplacement',
        en: 'Search/Replace',
      }}
      className={`${showReplace ? 'replace-active' : ''}`}
      image={img}
      width={16}
      height={16}
      onClick={onShowReplace}
    ></Button>
  );
}

function ResultText({ lang, currentPosition, totalWordsFounded }) {
  if (totalWordsFounded === 0) {
    return <p>{lang === 'fr' ? 'Aucun résultat' : 'No result'}</p>;
  }

  return (
    <p>
      {currentPosition === null ? 0 : currentPosition + 1}
      {lang === 'fr' ? ' sur ' : ' of '} {totalWordsFounded}{' '}
      {lang === 'fr' ? 'éléments' : 'items'}
    </p>
  );
}
